import { Box, Stack, Text } from "@mantine/core";
import AppointmentItem from "./AppointmentItem";
import AppointmentListQuery from "./AppointmentListQuery";
import classes from "../..//Home.module.css";
import { useTranslation } from "react-i18next";

export default function AppointmentList() {
  const { appointments } = AppointmentListQuery();
  const { t } = useTranslation("features");
  if (appointments.length == 0) {
    return (
      <Box className={classes.listContainer}>
        <Box className={classes.noListItem}>
          <Text w={"100%"} className={classes.listNoItemsText}>
            {t(`home.noAppointments`)}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Stack className={classes.listContainer} gap={8}>
      {appointments.map((appointment, index) => {
        return <AppointmentItem key={index} appointment={appointment} />;
      })}
    </Stack>
  );
}
